import React from "react";
import { Checkbox } from "../../../view/Checkbox";

function TargetTypeCheckboxElement({ element, onClick, disabled, index }) {

    return (
        <li className="addrules-target-item-v2" key={index}>
            <Checkbox checked={element.selected}
                onClick={disabled ? null : () => onClick(element)}
                disabled={disabled} />
            <span>{element.name}</span>
        </li>
    )
}

export default TargetTypeCheckboxElement;
